<template>
	<a-dropdown
		:trigger="['click']"
		class="mx-2"
	>
		<a-menu
			slot="overlay"

			@click="handleMenuClick"
		>
			<a-menu-item
				key="1"
				class="text-dark font-weight-bold"
			>
				<fa-icon
					icon="building"
					class="mr-2"
				/>Empresa
			</a-menu-item>
			<a-menu-item
				key="2"
				class="text-dark font-weight-bold"
			>
				<fa-icon
					icon="file-invoice"
					class="mr-2"
				/>Factura
			</a-menu-item>
			<a-menu-item
				key="3"
				class="text-dark font-weight-bold"
			>
				<fa-icon
					icon="receipt"
					class="mr-2"
				/>Presupuesto
			</a-menu-item>
		</a-menu>

		<a-button
			ghost
			type="dashed"
		>
			Crear <a-icon type="down" />
		</a-button>
	</a-dropdown>
</template>

<script>
export default {
	name: 'Shortcuts',
	methods: {
		handleMenuClick(e) {
			switch (e.key) {
				case '1':
					this.$router.push({ name: 'empresas_new' });
					break;

				case '2':
					this.$router.push({ name: 'facturas_new' });
					break;

				case '3':
					this.$router.push({ name: 'presupuestos_new' });
					break;

				default:
			}
		}
	}
};
</script>

<style lang="scss" scoped>

</style>
